// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"swiper-scroll_wrapper__rm1OR","slider":"swiper-scroll_slider__RlsOa","slide":"swiper-scroll_slide__f019_"};